import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  })

  if (event.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      event={event}
      page="Partner"
      title="What specific career or life experiences would you like the partner to have?"
      description={(
        <>
          <span className="text-bold italic">TIP</span>: Your event will appear in search results for any that you choose, so select all that could help.
        </>
      )}
    >
      <Form
        user={user}
        event={event}
        navigation={(
          <Navigation v5={true} activeStep={9} steps={13}/>
        )}
        onPrevious={(newData) => history.push(Urls(event).SLOTS)}
        onNext={(newData) => history.push(Urls(event).DATE)}
        onSkip={() => history.push(Urls(event).DATE)}
        onExit={() => history.push(Urls(event).EVENT_EDIT)}
      />
    </ParentLayout>
  );
};
